import { supabase } from "../supabase/supabaseClient";

// Conversations
export async function listConversations(userId) {
    return supabase
        .from("conversations")
        .select("id, initiator_id, recipient_id, status, last_message_at")
        .or(`initiator_id.eq.${userId},recipient_id.eq.${userId}`)
        .order("last_message_at", { ascending: false });
}

export async function createConversation(initiatorId, recipientId) {
    return supabase
        .from("conversations")
        .insert({ initiator_id: initiatorId, recipient_id: recipientId, status: "pending" })
        .select()
        .single();
}

export async function acceptConversation(conversationId) {
    return supabase
        .from("conversations")
        .update({ status: "accepted" })
        .eq("id", conversationId)
        .select()
        .single();
}

export async function declineConversation(conversationId) {
    return supabase
        .from("conversations")
        .update({ status: "declined" })
        .eq("id", conversationId)
        .select()
        .single();
}

export async function listUnreadByConversation(viewerId, conversationIds) {
    if (!conversationIds || conversationIds.length === 0) return { data: [], error: null };
    return supabase
        .from("messages")
        .select("conversation_id")
        .in("conversation_id", conversationIds)
        .neq("sender_id", viewerId)
        .is("read_at", null);
}

// Messages
export async function listMessages(conversationId) {
    return supabase
        .from("messages")
        .select("id, sender_id, body, created_at, read_at")
        .eq("conversation_id", conversationId)
        .order("created_at", { ascending: true });
}

export async function sendMessage(conversationId, senderId, body) {
    return supabase
        .from("messages")
        .insert({ conversation_id: conversationId, sender_id: senderId, body })
        .select()
        .single();
}

export async function markConversationRead(conversationId, viewerId) {
    return supabase
        .from("messages")
        .update({ read_at: new Date().toISOString() })
        .eq("conversation_id", conversationId)
        .neq("sender_id", viewerId)
        .is("read_at", null);
}
